module.exports = __webpack_public_path__ + "static/media/ListUserIcon.4e5b5cdb.svg";